// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1Zb3A","search":"Settings_search__xJtYq","filter":"Settings_filter__1oclU"};